/**
 * Default page size for job orders pagination
 */
const DEFAULT_PAGE_SIZE = 10;

export const MAX_SELECTED_JOB_ORDERS = 50;

export default DEFAULT_PAGE_SIZE;
